import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    mobileStepperDots: props => ({
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: '12px',
        height: props?.customStepperPropertys?.size || '8px' ,
        width:props?.customStepperPropertys?.size || '8px',
    }),
    nonActiveStepperDot: props =>({
        backgroundColor: props?.customStepperPropertys?.deactivecolor || theme.agentTheme.secondary.light,
    }),
    activeStepperDot: props => ({
        backgroundColor: props?.customStepperPropertys?.activecolor||  theme.agentTheme.secondary.main,
    })
}))

const CarouselStepperDots = ({ activeStep, handleStepChange, step ,customStepperPropertys}) => {
    const classes = useStyles({customStepperPropertys});
    return (
        <span onClick={()=>handleStepChange(step)} className={activeStep ? `${classes.mobileStepperDots} ${classes.activeStepperDot}` : `${classes.mobileStepperDots} ${classes.nonActiveStepperDot}`}></span>
    )
}

export default CarouselStepperDots;